import React from "react";
import { motion } from "framer-motion";

/**
 * Small fixed Scroll Down indicator pinned to bottom-right of viewport.
 * Hidden once user has scrolled near the bottom of the page.
 */
export const ScrollDownIndicator = ({ visible = true }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: visible ? 0.85 : 0, y: visible ? 0 : 12 }}
            transition={{ duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
            aria-hidden="true"
            style={{
                position: "fixed",
                right: 18,
                bottom: 24,         // moved lower — clears the scroll ruler
                zIndex: 60,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 8,
                fontFamily: "JetBrains Mono, monospace",
                fontSize: 9,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                color: "#fff",
                mixBlendMode: "difference",
                pointerEvents: "none",
                userSelect: "none",
            }}
            data-testid="scroll-down-indicator"
        >
            <div
                style={{
                    width: 22,
                    height: 34,
                    border: "1px solid currentColor",
                    borderRadius: 11,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                <motion.div
                    initial={{ y: 0, opacity: 1 }}
                    animate={{ y: [0, 14, 14], opacity: [1, 0, 1] }}
                    transition={{
                        duration: 1.8,
                        repeat: Infinity,
                        times: [0, 0.6, 1],
                        ease: [0.65, 0, 0.35, 1],
                    }}
                    style={{
                        position: "absolute",
                        left: "50%",
                        top: 6,
                        marginLeft: -1,
                        width: 2,
                        height: 6,
                        background: "currentColor",
                        borderRadius: 1,
                    }}
                />
            </div>
            <span>Scroll</span>
        </motion.div>
    );
};

export default ScrollDownIndicator;
